
import { BtnBox } from "../../style/common";
import Btn from "../common/Btn";
import GoBackBtn from "../common/GoBackBtn";

interface AddBtnsProps {
  onClick?: () => void;
  idx?: string;
}

export default function AddBtns({onClick}: AddBtnsProps) {
  return (
    <BtnBox>
      <Btn type="button" title="저장" color="blue" onClick={onClick} />
      <GoBackBtn />
    </BtnBox>
  );
}